export default "__VITE_ASSET__B8tPwJu6__"